import { useVisibleTeamsForUser } from './useVisibleTeamsForUser'

export const useUpcomingEventsForUser = (user: wowaudit.User | undefined) => {
  const visibleTeams = useVisibleTeamsForUser(user)

  if (!user) return []

  const visibleTeamIds = new Set(
    visibleTeams.map((teamReference) => teamReference.id),
  )
  const characterIds = new Set(
    user.characterReferences.map((characterReference) => characterReference.id),
  )

  return user.upcomingEvents.filter((eventReference) => {
    const hasOwnActiveParticipant = eventReference.participantReferences.some(
      (participantReference) =>
        characterIds.has(participantReference.characterId),
    )
    if (!hasOwnActiveParticipant) return false

    return (
      (eventReference.teamId && visibleTeamIds.has(eventReference.teamId)) ||
      eventReference.participantReferences.some(
        (participantReference) =>
          participantReference.addedAsGuest &&
          characterIds.has(participantReference.characterId),
      )
    )
  })
}
